// viewModalFieldOptions.js

const ROOT_FIELD_ORDER = ['autonumber', 'autokey', 'subtitle', 'dateCreated', 'dateModified'];

/**
 * Orders filter/sort field options with standard root fields first.
 */
export function buildOrderedFieldOptions(baseOptions = []) {
  const rootFields = [];
  const schemaFields = [];

  baseOptions.forEach((option) => {
    const value = option?.value;
    if (ROOT_FIELD_ORDER.includes(value)) {
      rootFields.push(option);
      return;
    }
    schemaFields.push(option);
  });

  const orderedRoots = ROOT_FIELD_ORDER
    .map((rootKey) => rootFields.find((option) => option?.value === rootKey))
    .filter(Boolean);

  const sortedSchemaFields = schemaFields.sort((a, b) => (
    String(a?.label || a?.value || '').localeCompare(
      String(b?.label || b?.value || ''),
      undefined,
      { sensitivity: 'base' },
    )
  ));

  return [...orderedRoots, ...sortedSchemaFields];
}
